import dialog_reservee_form  from './dialog_reservee_form';
import dialog_skier_types    from './dialog_skier_types';
import dialog_rental_rates   from './dialog_rental_rates';
import dialog_terms          from './dialog_terms';
import dialog_privacy_policy from './dialog_privacy_policy';
import dialog_cancelation_policy from './dialog_cancelation_policy';
import snowboard_type_save from './dialog_snowboard _type';
import dialog_show_packages_rate from './dialog_show_packages_rate';
import dialog_return_customer from './dialog_return_customer';
import dialog_prepay_return from './dialog_prepay_return';
import dialog_buddy_insurance from './dialog_buddy_insurance';
import dialog_delivery_address from './dialog_delivery_address';
import dialog_single_day_type from './dialog_single_day_type';
import dialog_welcome_text from './dialog_welcome_text';

export default {
    dialogs: [
        dialog_reservee_form,
        dialog_skier_types,
        dialog_rental_rates,
        dialog_terms,
        dialog_privacy_policy,
        snowboard_type_save,
        dialog_show_packages_rate,
        dialog_return_customer,
        dialog_prepay_return,
        dialog_buddy_insurance,
        dialog_delivery_address,
        dialog_single_day_type,
        dialog_welcome_text,
        dialog_cancelation_policy
    ],
    attach(store, dialogs) {
        for (let dialog of dialogs) {
            store.state.ui.availableModals[dialog.name] = dialog;
            for (let event in dialog.on) {
                const oldFn = dialog.on[event];
                dialog.on[event] = function () {
                    return oldFn(store, ...arguments);
                }
            }
        }
    }
}
